import {potionInstance, potionURI} from './metadata';
import {RequestOptions} from './potion';
import {isFunction} from './utils';


export type RouteType<T> = (params?: any, options?: RequestOptions) => Promise<T>;
/**
 * @template T
 * @param {?} path
 * @param {?=} __1
 * @return {?}
 */
export function route<T>(path: string, {method}: RequestOptions = {}): RouteType<T> {
    // tslint:disable-next-line:only-arrow-functions
    return function(this: any, params?: any, {paginate = false, cache = true}: RequestOptions = {}): Promise<T> {
        const /** @type {?} */ isCtor = isFunction(this);
        const /** @type {?} */ uri = `${isCtor ? potionURI(this) : this.uri}${path}`;

        const /** @type {?} */ options: RequestOptions = {method, paginate, cache};
        if (method === 'GET') {
            options.params = params;
        } else if (( /** @type {?} */((['POST', 'PUT', 'PATCH'] as any))).includes(method)) {
            options.body = params;
        }

        return potionInstance(isCtor ? this : this.constructor)
            .fetch(uri, options);
    };
}
// tslint:enable:no-invalid-this

/**
 * Use the Route object methods to register other REST methods on a resource.
 *
 * @example
 * class User extends Item {
 *     static readSiblings = Route.GET('/siblings');
 *     createSibling = Route.POST('/sibling');
 * }
 */
// tslint:disable-next-line:variable-name
export const /** @type {?} */ Route = {
/**
 * @template T
 * @param {?} uri
 * @return {?}
 */
GET<T>(uri: string): RouteType<T> {
        return route<T>(uri, {
            method: 'GET'
        });
    },
/**
 * @template T
 * @param {?} uri
 * @return {?}
 */
DELETE<T>(uri: string): RouteType<T> {
        return route<T>(uri, {
            method: 'DELETE'
        });
    },
/**
 * @template T
 * @param {?} uri
 * @return {?}
 */
POST<T>(uri: string): RouteType<T> {
        return route<T>(uri, {
            method: 'POST'
        });
    },
/**
 * @template T
 * @param {?} uri
 * @return {?}
 */
PATCH<T>(uri: string): RouteType<T> {
        return route<T>(uri, {
            method: 'PATCH'
        });
    },
/**
 * @template T
 * @param {?} uri
 * @return {?}
 */
PUT<T>(uri: string): RouteType<T> {
        return route<T>(uri, {
            method: 'PUT'
        });
    }
};
